<template>
  <q-tabs
    v-model="tab"
    dense
    outside-arrows
    mobile-arrows
    :class="this.$q.dark.mode === true ? 'bg-grey-10' : 'text-grey-9 bg-grey-4'"
    active-color="white"
    :active-bg-color="this.$q.dark.mode === true ? 'grey-9' : 'blue-4'"
    :indicator-color="this.$q.dark.mode === true ? 'grey-7' : 'blue-5'"
    align="justify"
    narrow-indicator
  >
    <!-- <q-tab name="basic_info" label="Info"></q-tab> -->
    <!-- <q-tab name="floorsheet" label="Floorsheet"></q-tab> -->
    <!-- <q-tab name="broker_analytics" label="Broker"></q-tab> -->
    <!-- <q-tab name="quarterly_report" label="Quarter Report"></q-tab> -->
  </q-tabs>

  <q-separator></q-separator>
  <q-tab-panels v-model="tab" animated>
    <q-tab-panel name="basic_info" :class="chartRightBar ? 'q-pa-none' : 'q-pa-xs'">
      <StockWiseEssentialStatistics :symbol="symbol" :stock="stock" />
    </q-tab-panel>

    <q-tab-panel name="floorsheet" :class="chartRightBar ? 'q-pa-none' : 'q-pa-xs'">
      <!-- <StockWiseFloorSheet :symbol="symbol" /> -->
    </q-tab-panel>

    <q-tab-panel
      name="broker_analytics"
      :class="chartRightBar ? 'q-pa-none' : 'q-pa-xs'"
    >
      <!-- <StockWiseBrokerAnalytics :symbol="symbol" /> -->
    </q-tab-panel>

    <q-tab-panel
      name="quarterly_report"
      :class="chartRightBar ? 'q-pa-none' : 'q-pa-xs'"
    >
      <!-- <StockWiseFYComparison :symbol="symbol" /> -->
    </q-tab-panel>
  </q-tab-panels>
</template>

<script>
import { ref} from "vue";
// import StockWiseBrokerAnalytics from "src/components/StockWiseBrokerAnalytics.vue";
// import StockWiseDimensionCharts from "src/components/StockWiseDimensionCharts.vue";
// import StockWiseFYComparison from "src/components/StockWiseFYComparison.vue";
// import StockWiseFloorSheet from "src/components/StockWiseFloorSheet.vue";
import StockWiseEssentialStatistics from "src/components/StockWiseEssentialStatistics.vue";

export default {
  name: "StockWiseChartEssential",
  props: {
    viewLarge: {
      type: Boolean,
      default: false,
    },
    symbol: {
      type: String,
      required: true,
    },
    chartRightBar: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    // StockWiseBrokerAnalytics,
    // StockWiseFYComparison,
    // StockWiseDimensionCharts,
    // StockWiseFloorSheet,
    StockWiseEssentialStatistics,
  },
  setup(props) {
    const stock = ref(null);

    // const getEssentialStats = (symbol) => {
    //   stockSearch(symbol)
    //     .then((data) => {
    //       stock.value = data;

    //       allSector().then((res) => {
    //         stock.value.sector_name = res.data.find(
    //           (sector) => sector.id == stock.value.sector
    //         ).name;
    //       });

    //       historyDataSearch(symbol).then((res) => {
    //         var tradingData52Weeks = res.data.slice(0, 312);

    //         stock.value.latestTrades = {
    //           last_trade: res.data[0].close?.toFixed(2),
    //           last_trade_diff: (res.data[0].close - res.data[1].close)?.toFixed(
    //             2
    //           ),
    //           week_high_52: tradingData52Weeks
    //             .slice()
    //             .sort((a, b) => b.close - a.close)[0]
    //             .close?.toFixed(2),
    //           week_low_52: tradingData52Weeks
    //             .slice()
    //             .sort((a, b) => a.close - b.close)[0]
    //             .close?.toFixed(2),
    //           days_avg_120: (
    //             tradingData52Weeks.slice(0, 120).reduce((acc, curr) => {
    //               return acc + curr.close;
    //             }, 0) / 120
    //           )?.toFixed(2),
    //         };

    //         // stockReport(stock.value.id).then((res) => {
    //         //   var latestStockReport = res.data[0];

    //         //   stock.value.latestReport = {
    //         //     fiscal_year: latestStockReport?.fiscal_year,
    //         //     quarter: latestStockReport?.quarter,
    //         //     eps: latestStockReport.eps?.toFixed(2),
    //         //     npl: latestStockReport.npl?.toFixed(2),
    //         //     roe: latestStockReport.roe?.toFixed(2),
    //         //     roa: latestStockReport.roa?.toFixed(2),
    //         //     net_worth: latestStockReport.net_worth?.toFixed(2),
    //         //     growth_rate: latestStockReport.growth_rate?.toFixed(2),
    //         //     paidup_capital: latestStockReport?.paidup_capital,
    //         //     graham_number: latestStockReport?.gram_value?.toFixed(2),
    //         //     peg_value: latestStockReport.peg_value?.toFixed(2),
    //         //     pe_ratio: latestStockReport.pe_ratio?.toFixed(2),
    //         //   };

    //         //   stock.value.latestReport["adjusted_graham_number"] =
    //         //     parseFloat(stock.value.latestReport?.eps) > 0
    //         //       ? (
    //         //           (parseFloat(stock.value.latestReport.eps) *
    //         //             (8.5 +
    //         //               parseFloat(stock.value.latestReport.growth_rate)) *
    //         //             4.4) /
    //         //           6
    //         //         )?.toFixed(2)
    //         //       : " ";
    //         // });

    //         // bonus(stock.value.symbol).then((res) => {
    //         //   var latestStockBonus = res.data[0];

    //         //   stock.value.latestBonus = {
    //         //     bonus: latestStockBonus?.bonus?.toFixed(2),
    //         //     cash: latestStockBonus?.cash?.toFixed(2),
    //         //     total: latestStockBonus?.total?.toFixed(2),
    //         //   };
    //         // });
    //       });
    //     })
    //     .catch((error) => {
    //       console.log(error);
    //     })
    //     .finally(() => {
    //       stock.value = stock.value;
    //     });
    // };

    // onMounted(() => {
    //   getEssentialStats(props.symbol);
    // });

    // watch(props, (newProps, oldProps) => {
    //   getEssentialStats(newProps.symbol);
    // });

    return {
      stock,
      tab: ref("basic_info"),
    };
  },
};
</script>
